var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifiedBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "task_alt"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7619_33086",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7619_33086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "task_alt_2",
    d: "M8.00016 14.6666C7.07794 14.6666 6.21127 14.4916 5.40016 14.1416C4.58905 13.7916 3.8835 13.3166 3.2835 12.7166C2.6835 12.1166 2.2085 11.4111 1.8585 10.6C1.5085 9.78887 1.3335 8.9222 1.3335 7.99998C1.3335 7.07776 1.5085 6.21109 1.8585 5.39998C2.2085 4.58887 2.6835 3.88331 3.2835 3.28331C3.8835 2.68331 4.58905 2.20831 5.40016 1.85831C6.21127 1.50831 7.07794 1.33331 8.00016 1.33331C8.5335 1.33331 9.05294 1.39442 9.5585 1.51665C10.0641 1.63887 10.5502 1.81665 11.0168 2.04998C11.1835 2.13887 11.2918 2.2722 11.3418 2.44998C11.3918 2.62776 11.3613 2.79442 11.2502 2.94998C11.1391 3.10554 10.9918 3.20554 10.8085 3.24998C10.6252 3.29442 10.4446 3.2722 10.2668 3.18331C9.91127 3.01665 9.54183 2.88887 9.1585 2.79998C8.77516 2.71109 8.38905 2.66665 8.00016 2.66665C6.52238 2.66665 5.26405 3.18609 4.22516 4.22498C3.18627 5.26387 2.66683 6.5222 2.66683 7.99998C2.66683 9.47776 3.18627 10.7361 4.22516 11.775C5.26405 12.8139 6.52238 13.3333 8.00016 13.3333C9.47794 13.3333 10.7363 12.8139 11.7752 11.775C12.8141 10.7361 13.3335 9.47776 13.3335 7.99998C13.3335 7.91109 13.3307 7.82498 13.3252 7.74165C13.3196 7.65831 13.3113 7.5722 13.3002 7.48331C13.2779 7.29442 13.3141 7.11387 13.4085 6.94165C13.5029 6.76942 13.6446 6.65553 13.8335 6.59998C14.0113 6.54442 14.1779 6.56109 14.3335 6.64998C14.4891 6.73887 14.5779 6.8722 14.6002 7.04998C14.6224 7.20553 14.6391 7.36109 14.6502 7.51665C14.6613 7.6722 14.6668 7.83331 14.6668 7.99998C14.6668 8.9222 14.4918 9.78887 14.1418 10.6C13.7918 11.4111 13.3168 12.1166 12.7168 12.7166C12.1168 13.3166 11.4113 13.7916 10.6002 14.1416C9.78905 14.4916 8.92238 14.6666 8.00016 14.6666ZM7.06683 9.19998L13.2668 2.98331C13.3891 2.86109 13.5418 2.7972 13.7252 2.79165C13.9085 2.78609 14.0668 2.84998 14.2002 2.98331C14.3224 3.10554 14.3835 3.26109 14.3835 3.44998C14.3835 3.63887 14.3224 3.79442 14.2002 3.91665L7.5335 10.6C7.40016 10.7333 7.24461 10.8 7.06683 10.8C6.88905 10.8 6.7335 10.7333 6.60016 10.6L4.70016 8.69998C4.57794 8.57776 4.51683 8.4222 4.51683 8.23331C4.51683 8.04442 4.57794 7.88887 4.70016 7.76665C4.82238 7.64442 4.97794 7.58331 5.16683 7.58331C5.35572 7.58331 5.51127 7.64442 5.6335 7.76665L7.06683 9.19998Z",
    fill: "#A9CF3D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedBtn);
export default __webpack_public_path__ + "static/media/verified_btn.ea5fc14f34ed461724899e19bcbe9192.svg";
export { ForwardRef as ReactComponent };